var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#FFF3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74967 11.4582V13.6248M15.2497 10.3748V12.5415M14.708 7.6665C16.0344 7.6665 16.7518 7.8695 17.1087 8.02695C17.1563 8.04792 17.18 8.0584 17.2486 8.12387C17.2898 8.16311 17.3648 8.27826 17.3841 8.33172C17.4163 8.4209 17.4163 8.46965 17.4163 8.56716V14.3892C17.4163 14.8815 17.4163 15.1276 17.3425 15.2541C17.2674 15.3828 17.195 15.4426 17.0545 15.4921C16.9163 15.5407 16.6374 15.4871 16.0796 15.3799C15.6892 15.3049 15.2261 15.2498 14.708 15.2498C13.083 15.2498 11.458 16.3332 9.29134 16.3332C7.96496 16.3332 7.24756 16.1302 6.89061 15.9727C6.84307 15.9518 6.81931 15.9413 6.75071 15.8758C6.70959 15.8366 6.63453 15.7214 6.61522 15.668C6.58301 15.5788 6.58301 15.53 6.58301 15.4325L6.58301 9.61047C6.58301 9.11822 6.58301 8.87209 6.65683 8.74558C6.73191 8.61689 6.80433 8.55707 6.94487 8.50761C7.08304 8.45899 7.36194 8.51258 7.91975 8.61975C8.31018 8.69477 8.77323 8.74984 9.29134 8.74984C10.9163 8.74984 12.5413 7.6665 14.708 7.6665ZM13.3538 11.9998C13.3538 12.7477 12.7476 13.354 11.9997 13.354C11.2518 13.354 10.6455 12.7477 10.6455 11.9998C10.6455 11.252 11.2518 10.6457 11.9997 10.6457C12.7476 10.6457 13.3538 11.252 13.3538 11.9998Z",
    stroke: "#FA5DB6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/cheque.46daea606e4444bdf9201cd0c40845eb.svg";
export { ForwardRef as ReactComponent };